import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArray',
  pure: false
})
export class FilterArray implements PipeTransform {

  transform(values: any[], filterValue: string): any[] {
    if (!values) {
      return;
    }
    let subArray = values;
    subArray = subArray.filter(a => a.isActive === JSON.parse(filterValue));
    return subArray;
  }
}
